import React, { Component } from 'react';
import { Map, LayersControl } from 'react-leaflet';
import { latLngBounds, latLng } from 'leaflet';
import { GoogleLayer } from 'react-leaflet-google';
import PropTypes from 'prop-types';
import isBadCoordinate from '../../../utils/isBadCoordinate';
import { API_KEY } from '../../../config';
import { MAP_TYPES } from '../../../constants';
import MapMarkers from '../../Map/MapMarkers';
// import AreasLayer from '../../Map/Layers/Areas';

import './FoldersMap.css';

const { BaseLayer } = LayersControl;

// const location = { lat: 29.824592, lng: -95.18663 };

export class FoldersMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bounds: null,
      hasInterracted: false,
      addLayers: false,
      // zoom: Math.clamp(this.props.defaultZoom, -2, 2),
      zoom: 7,
    };
  }

  componentDidMount() {
    const { properties } = this.props;
    if (properties && properties.length && !this.state.bounds) {
      this.setBoundsFromProperties(properties);
    }

    // Register event on leaflet map to set interracted when someone drags it
    if (this.mapRefFolders.leafletElement) {
      this.mapRefFolders.leafletElement.once({
        drag: this.onInterract,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { properties } = nextProps;
    // console.log('old properties:', this.props.properties);
    // console.log('next properties:', nextProps.properties);
    if (properties && properties.length &&
      this.props.properties.length !== properties.length) {
      this.setBoundsFromProperties(properties);
    }
  }

  onInterract = () => {
    this.setState({ hasInterracted: true });
  }

  setBoundsFromProperties = properties => {
    const coordinates = properties.reduce((map, property) => {
      if (property.coordinates !== undefined) {
        const coords = property.coordinates.map(coordinate => parseFloat(coordinate));
        map.push([coords[1], coords[0]]);
      }
      return map;
    }, [])
    .filter(bound => {
      return !isBadCoordinate(bound[0]) || !isBadCoordinate(bound[1]);
    });
    if (coordinates.length) {
      this.updateBounds(coordinates);
    }
  }

  // setInitialMapView = () => {
  //   this.pendingMapView = setTimeout(() => {
  //     this.setState(prevState => ({
  //       ...prevState,
  //       // mapView: this.props.mapType,
  //       ready: true,
  //     }), () => {
  //       this.pendingMapView = null;
  //       this.updateAddLayers(true);
  //     });
  //   }, 1000);
  // }

  updateBounds = coordinates => {
    const { hasInterracted, zoom } = this.state;

    if (hasInterracted) {
      return;
    }

    let bounds;
    if (Array.isArray(coordinates)) {
      bounds = coordinates.length > 1
      ? latLngBounds(coordinates)
      : latLng(coordinates[0]).toBounds(500);
    } else {
      bounds = coordinates;
    }

    if (zoom) {
      const curZoom = this.mapRefFolders.leafletElement.getBoundsZoom(bounds);
      // console.log('curZoom', curZoom);
      this.mapRefFolders.leafletElement.setView(bounds.getCenter(), curZoom);
      bounds = this.mapRefFolders.leafletElement.getBounds();
    }
    // this.mapRefFolders.leafletElement.fitBounds(bounds);
    this.setState({
      bounds,
    });
    // console.log('bounds updated:', bounds);
  }

  render() {
    const { handleModalOpen, onViewportChanged, properties } = this.props;
    const boundsProp = this.state.bounds ? { bounds: this.state.bounds } : {};
    return (
      <section id="foldersMapRef" className="folders-map">
        <div className="folders-map-wrapper">
          <Map
            // center={location}
            ref={map => { this.mapRefFolders = map; }}
            zoom={this.state.zoom}
            scrollWheelZoom={false}
            whenReady={function whenReady() {
              // this.setInitialMapView();
              onViewportChanged({ bounds: this.getBounds() });
            }}
            onViewportChanged={viewport => {
              if (this.mapRefFolders) {
                onViewportChanged(
                  { ...viewport, bounds: this.mapRefFolders.leafletElement.getBounds() });
              }
            }}
            {...boundsProp}
            // mapChildren={[(
            //   <div key="areasLayer">
            //     {
            //       Object.keys(areaAll).length > 0 &&
            //       <AreasLayer
            //         activeColor={activeColor}
            //         layer={layer}
            //         areas={areaAll}
            //       />
            //     }
            //   </div>
            // )]}
          >
            <LayersControl position="topright">
              <BaseLayer checked name="Roads">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.ROADMAP} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Terrain">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.TERRAIN} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Satellite">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.SATELLITE} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Hybrid">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.HYBRID} libraries={['geometry', 'places']} />
              </BaseLayer>
            </LayersControl>
            {properties &&
              <MapMarkers showMarkerNumbers properties={properties} type="" handleModalOpen={handleModalOpen} />
            }
          </Map>
        </div>
      </section>
    );
  }
}

FoldersMap.propTypes = {
  // defaultZoom: PropTypes.number,
  handleModalOpen: PropTypes.func,
  onViewportChanged: PropTypes.func,
  properties: PropTypes.arrayOf(PropTypes.object),
};

export default FoldersMap;



// WEBPACK FOOTER //
// ./src/components/Favorites/FoldersMap/FoldersMap.js